import type { LumpsumIdealCategory, LumpsumIdealRecommendation } from '../../../api/ideal.types'
import { CategoryCard } from '../../lumpsum-ui-components/CategoryCard'
import { PlansCategoryRangeTrailing } from '../../lumpsum-ui-components/PlansCategoryRangeTrailing'
import { IdealFundCard } from './cards/IdealFundCard'
import { buildPlanAllocationRangeLabel } from '../../../../display-values/lumpsumPlanPercentage'

type IdealCategoryCardProps = {
  category: LumpsumIdealCategory
  categoryIndex: number
  noDivider?: boolean
}

export function IdealCategoryCard({ category, categoryIndex, noDivider = false }: IdealCategoryCardProps) {
  const categoryId = category?.categoryId ?? `ideal-category-${categoryIndex}`
  const label = category?.categoryName ?? categoryId.replace(/_/g, ' ')
  const categoryAllocationRangeLabel = buildPlanAllocationRangeLabel({ idealAllocation: category?.idealAllocationPercentage })
  const funds: LumpsumIdealRecommendation[] = category?.idealFunds ?? []

  return (
    <CategoryCard
      label={label}
      trailing={<PlansCategoryRangeTrailing label={categoryAllocationRangeLabel} showIdealRangeLabel={false} />}
      noDivider={noDivider}
    >
      <div className="flex flex-col gap-5 py-5">
        {funds.map((fund, fundIndex) => (
          <IdealFundCard
            key={`${fund?.isin ?? 'fund'}-${fundIndex}`}
            fund={fund}
            showBottomDivider={fundIndex < funds.length - 1}
          />
        ))}
      </div>
    </CategoryCard>
  )
}
